import { IRecommendedRivalsState } from "../reducers/StatsReducers"

export const GET_TOP_N_SCORES_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_SCORES_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_SCORES_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_SCORES_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_SCORES_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_SCORES_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_TOP_N_PLAYS_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_PLAYS_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_PLAYS_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_PLAYS_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_PLAYS_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_PLAYS_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_USER_PLAYS_OVER_TIME_ACTION_TYPE = 'GET_USER_PLAYS_OVER_TIME_ACTION_TYPE'
export const GET_USER_PLAYS_OVER_TIME_SUCCEEDED_ACTION_TYPE = 'GET_USER_PLAYS_OVER_TIME_SUCCEEDED_ACTION_TYPE'
export const GET_USER_PLAYS_OVER_TIME_FAILED_ACTION_TYPE = 'GET_USER_PLAYS_OVER_TIME_FAILED_ACTION_TYPE'

export const GET_USER_PLAYS_PER_TIME_OF_DAY_ACTION_TYPE = 'GET_USER_PLAYS_PER_TIME_OF_DAY_ACTION_TYPE'
export const GET_USER_PLAYS_PER_TIME_OF_DAY_SUCCEEDED_ACTION_TYPE = 'GET_USER_PLAYS_PER_TIME_OF_DAY_SUCCEEDED_ACTION_TYPE'
export const GET_USER_PLAYS_PER_TIME_OF_DAY_FAILED_ACTION_TYPE = 'GET_USER_PLAYS_PER_TIME_OF_DAY_FAILED_ACTION_TYPE'

export const GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_ACTION_TYPE = 'GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_ACTION_TYPE'
export const GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_SUCCEEDED_ACTION_TYPE = 'GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_SUCCEEDED_ACTION_TYPE'
export const GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_FAILED_ACTION_TYPE = 'GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_FAILED_ACTION_TYPE'

export const GET_USER_SCORES_TAKEN_LEADERBOARD_ACTION_TYPE = 'GET_USER_SCORES_TAKEN_LEADERBOARD_ACTION_TYPE'
export const GET_USER_SCORES_TAKEN_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_USER_SCORES_TAKEN_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_USER_SCORES_TAKEN_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_USER_SCORES_TAKEN_LEADERBOARD_FAILED_ACTION_TYPE'

export const GET_USER_SEASONS_PROGRESS_ACTION_TYPE = 'GET_USER_SEASONS_PROGRESS_ACTION_TYPE'
export const GET_USER_SEASONS_PROGRESS_SUCCEEDED_ACTION_TYPE = 'GET_USER_SEASONS_PROGRESS_SUCCEEDED_ACTION_TYPE'
export const GET_USER_SEASONS_PROGRESS_FAILED_ACTION_TYPE = 'GET_USER_SEASONS_PROGRESS_FAILED_ACTION_TYPE'

export const GET_USER_RECOMMENDED_RIVALS_ACTION_TYPE = 'GET_USER_RECOMMENDED_RIVALS_ACTION_TYPE'
export const GET_USER_RECOMMENDED_RIVALS_SUCCEEDED_ACTION_TYPE = 'GET_USER_RECOMMENDED_RIVALS_SUCCEEDED_ACTION_TYPE'
export const GET_USER_RECOMMENDED_RIVALS_FAILED_ACTION_TYPE = 'GET_USER_RECOMMENDED_RIVALS_FAILED_ACTION_TYPE'

export const GET_USER_NEXT_SCORES_TO_TAKE_ACTION_TYPE = 'GET_USER_NEXT_SCORES_TO_TAKE_ACTION_TYPE'
export const GET_USER_NEXT_SCORES_TO_TAKE_SUCCEEDED_ACTION_TYPE = 'GET_USER_NEXT_SCORES_TO_TAKE_SUCCEEDED_ACTION_TYPE'
export const GET_USER_NEXT_SCORES_TO_TAKE_FAILED_ACTION_TYPE = 'GET_USER_NEXT_SCORES_TO_TAKE_FAILED_ACTION_TYPE'

export const GET_USER_PACK_PROGRESS_ACTION_TYPE = 'GET_USER_PACK_PROGRESS_ACTION_TYPE'
export const GET_USER_PACK_PROGRESS_SUCCEEDED_ACTION_TYPE = 'GET_USER_PACK_PROGRESS_SUCCEEDED_ACTION_TYPE'
export const GET_USER_PACK_PROGRESS_FAILED_ACTION_TYPE = 'GET_USER_PACK_PROGRESS_FAILED_ACTION_TYPE'

export const GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_ACTION_TYPE = 'GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_ACTION_TYPE'
export const GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_SUCCEEDED_ACTION_TYPE = 'GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_SUCCEEDED_ACTION_TYPE'
export const GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_FAILED_ACTION_TYPE = 'GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_FAILED_ACTION_TYPE'

export const MAX_LEADERBOARD_ENTRIES = 10;
export const MAX_USER_SCORES_TAKEN_LEADERBOARD_ENTRIES = 10000;
export const MAX_PLAYS_PER_COUNTRY_LEADERBOARD_ENTRIES = 1000;

export interface IUserRankingType {
    userExternalId: string,
    userName: string,
    count: number,
}

export interface IDateValueStatisticsType {
    date: Date,
    value: number,
}

export interface IDayHourValueStatisticsType {
    dayOfWeek: number,
    hour: number,
    value: number,
}

export interface IMaxDifficultyPassStatisticsType extends IDateValueStatisticsType {
    notechartName: string,
    songName: string,
}

export interface INamedRankingType {
    externalId: string,
    name: string,
    count: number,
}

export interface IPerYearRankingsType {
    year: number,
    rankings: Array<INamedRankingType>,
}

export interface IPerYearAndMonthRankingsType {
    year: number,
    month: number,
    rankings: Array<INamedRankingType>,
}

export interface IRelationshipRankingsType {
    from: string,
    to: string,
    value: number,
}

export interface IUserNextScoreToTakeType {
    nextScoreUserName: string,
    songName: string,
    notechartName: string,
    userScore: number,
    nextScore: number,
}

export interface IUserRecommendedRivalType {
    difficultyRivalUserName: string,
    difficultyTimingRivalUserName: string,
    scoresDifficultyRivalUserName: string,
    scoresDifficultyTimingRivalUserName: string,
    scoresRivalUserName: string,
    scoresTimingRivalUserName: string,
    timingRivalUserName: string,
}

export interface ISeasonProgressStatisticsType {
    seasonName: string,
    totalSinglesChartsCount: number,
    totalDoublesChartsCount: number,
    singlesChartsPurpleAwardCount: number,
    doublesChartsPurpleAwardCount: number,
    singlesChartsBlueAwardCount: number,
    doublesChartsBlueAwardCount: number,
    singlesChartsGreenAwardCount: number,
    doublesChartsGreenAwardCount: number,
    singlesChartsYellowAwardCount: number,
    doublesChartsYellowAwardCount: number,
    singlesChartsRedAwardCount: number,
    doublesChartsRedAwardCount: number,
}

export interface IPackProgressStatisticsType {
    packExternalId: string,
    packName: string,
    totalSinglesChartsCount: number,
    totalDoublesChartsCount: number,
    singlesChartsPurpleAwardCount: number,
    doublesChartsPurpleAwardCount: number,
    singlesChartsBlueAwardCount: number,
    doublesChartsBlueAwardCount: number,
    singlesChartsGreenAwardCount: number,
    doublesChartsGreenAwardCount: number,
    singlesChartsYellowAwardCount: number,
    doublesChartsYellowAwardCount: number,
    singlesChartsRedAwardCount: number,
    doublesChartsRedAwardCount: number,
}

export interface ICountryRankingType {
    countryIsoCode: string,
    count: number,
}

export interface ILoadTopNScoresLeaderboardSucceededAction {
    type: typeof GET_TOP_N_SCORES_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IUserRankingType>,
    }
}

export interface ILoadTopNPlaysLeaderboardSucceededAction {
    type: typeof GET_TOP_N_PLAYS_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IUserRankingType>,
    }
}

export interface ILoadTopNNotechartArtistsLeaderboardSucceededAction {
    type: typeof GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IUserRankingType>,
    }
}

export interface ILoadTopNChartsPerYearLeaderboardSucceededAction {
    type: typeof GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IPerYearRankingsType>,
    }
}

export interface ILoadTopNChartsPerYearAndMonthLeaderboardSucceededAction {
    type: typeof GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IPerYearAndMonthRankingsType>,
    }
}

export interface ILoadTopNSongsPerYearLeaderboardSucceededAction {
    type: typeof GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IPerYearRankingsType>,
    }
}

export interface ILoadTopNSongsPerYearAndMonthLeaderboardSucceededAction {
    type: typeof GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IPerYearAndMonthRankingsType>,
    }
}

export interface IGetUserPlaysOverTimeSucceededAction {
    type: typeof GET_USER_PLAYS_OVER_TIME_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IDateValueStatisticsType>,
    }
}

export interface IGetUserPlaysPerTimeOfDaySucceededAction {
    type: typeof GET_USER_PLAYS_PER_TIME_OF_DAY_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IDayHourValueStatisticsType>,
    }
}

export interface IGetUserMaxDifficultyPassesOverTimeSucceededAction {
    type: typeof GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_SUCCEEDED_ACTION_TYPE;
    json: {
        singlesMaxPassedResults: Array<IMaxDifficultyPassStatisticsType>,
        doublesMaxPassedResults: Array<IMaxDifficultyPassStatisticsType>,
    }
}

export interface ILoadUserScoresTakenLeaderboardSucceededAction {
    type: typeof GET_USER_SCORES_TAKEN_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IRelationshipRankingsType>,
    }
}

export interface IGetUserSeasonsProgressSucceededAction {
    type: typeof GET_USER_SEASONS_PROGRESS_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<ISeasonProgressStatisticsType>,
    }
}

export interface IGetUserRecommendedRivalsSucceededAction {
    type: typeof GET_USER_RECOMMENDED_RIVALS_SUCCEEDED_ACTION_TYPE;
    json: IUserRecommendedRivalType,
}

export interface IGetUserNextScoresToTakeSucceededAction {
    type: typeof GET_USER_NEXT_SCORES_TO_TAKE_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<IUserNextScoreToTakeType>,
    }
}

export interface IGetUserPackProgressSucceededAction {
    type: typeof GET_USER_PACK_PROGRESS_SUCCEEDED_ACTION_TYPE;
    json: IPackProgressStatisticsType,
}

export interface ILoadTopNPlaysPerCountryLeaderboardSucceededAction {
    type: typeof GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_SUCCEEDED_ACTION_TYPE;
    json: {
        results: Array<ICountryRankingType>,
    }
}

// Loads the top N scores leaderboard from the server.
export const createLoadTopNScoresLeaderboardAction = () => {
    return {
        type: GET_TOP_N_SCORES_LEADERBOARD_ACTION_TYPE,
    }
};

export const createLoadTopNPlaysLeaderboardAction = () => {
    return {
        type: GET_TOP_N_PLAYS_LEADERBOARD_ACTION_TYPE,
    }
};

export const createLoadTopNNotechartArtistsLeaderboardAction = () => {
    return {
        type: GET_TOP_N_NOTECHART_ARTISTS_LEADERBOARD_ACTION_TYPE,
    }
};

export const createGetUserPlaysOverTimeAction = () => {
    return {
        type: GET_USER_PLAYS_OVER_TIME_ACTION_TYPE,
    }
};

export const createGetUserPlaysPerTimeOfDayAction = () => {
    return {
        type: GET_USER_PLAYS_PER_TIME_OF_DAY_ACTION_TYPE,
    }
};

export const createGetUserMaxDifficultyPassesOverTimeAction = () => {
    return {
        type: GET_USER_MAX_DIFFICULTY_PASSES_OVER_TIME_ACTION_TYPE,
    }
};

export const createLoadTopNChartsPerYearLeaderboardAction = () => {
    return {
        type: GET_TOP_N_CHARTS_PER_YEAR_LEADERBOARD_ACTION_TYPE,
    }
};

export const createLoadTopNChartsPerYearAndMonthLeaderboardAction = () => {
    return {
        type: GET_TOP_N_CHARTS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE,
    }
};

export const createLoadTopNSongsPerYearLeaderboardAction = () => {
    return {
        type: GET_TOP_N_SONGS_PER_YEAR_LEADERBOARD_ACTION_TYPE,
    }
};

export const createLoadTopNSongsPerYearAndMonthLeaderboardAction = () => {
    return {
        type: GET_TOP_N_SONGS_PER_YEAR_AND_MONTH_LEADERBOARD_ACTION_TYPE,
    }
};

export const createLoadUserScoresTakenLeaderboardAction = () => {
    return {
        type: GET_USER_SCORES_TAKEN_LEADERBOARD_ACTION_TYPE,
    }
};

export const createGetUserSeasonsProgressAction = () => {
    return {
        type: GET_USER_SEASONS_PROGRESS_ACTION_TYPE,
    }
};

export const createGetUserRecommendedRivalsAction = () => {
    return {
        type: GET_USER_RECOMMENDED_RIVALS_ACTION_TYPE,
    }
};

export const createGetUserNextScoresToTakeAction = () => {
    return {
        type: GET_USER_NEXT_SCORES_TO_TAKE_ACTION_TYPE,
    }
};

export const createGetUserPackProgressAction = () => {
    return {
        type: GET_USER_PACK_PROGRESS_ACTION_TYPE,
    }
};

export const createLoadTopNPlaysPerCountryLeaderboardAction = () => {
    return {
        type: GET_TOP_N_PLAYS_PER_COUNTRY_LEADERBOARD_ACTION_TYPE,
    }
};
